import React from "react";
import { useSelector } from "react-redux";
import Icon from "../../icons/Icon";
import iconsList from "../../icons/iconsList";
import classes from "./ImageUploadRequirementsBanner.module.css";

const ImageUploadRequirementsBanner = ({ isError = false, maxSizeBytes, bannerKey }) => {
    const { texts } = useSelector((state) => state.translate);
    const bannerLabel = bannerKey ? texts[`${bannerKey}Label`] : null;
    const bannerValue = bannerKey ? texts[`${bannerKey}Value`] : null;

    const formatFileSize = (bytes) => {
        if (bytes >= 1024 * 1024)
            return `${Math.round(bytes / (1024 * 1024))}MB`;
        if (bytes >= 1024)
            return `${Math.round(bytes / 1024)}KB`;
        return `${bytes}B`;
    };

    return (
        <div className={`${classes.Banner} ${isError ? classes.Error : classes.Info}`}>
            <Icon name={iconsList.scheduleFileInfo} size="16px" className={classes.Icon} />
            <p className={classes.Details}>
                <span className={classes.Label}>{texts.imageUploadTypeLabel}</span>
                <span>{texts.imageUploadTypeValue}</span>
                <span className={classes.Separator}> | </span>
                <span className={classes.Label}>{texts.imageUploadMaxSizeLabel}</span>
                <span>{formatFileSize(maxSizeBytes)}</span>
                {(bannerLabel || bannerValue) && <>
                    <span className={classes.Separator}> | </span>
                    {bannerLabel && <span className={classes.Label}>{bannerLabel}</span>}
                    {bannerValue && <span>{bannerValue}</span>}
                </>}
            </p>
        </div>
    );
};

export default ImageUploadRequirementsBanner;
